import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { getHelpCenterTopBarSplitFlag } from 'state/selectors/help-center';
import { isCustomizing } from 'state/selectors/help-center-preview';
import { ElementRoot } from './element-root';

const selector = createSelector(isCustomizing, getHelpCenterTopBarSplitFlag, (customizing, hasTopBarBeenSplit) => ({
    hasTopBarBeenSplit,
    isCustomizing: customizing,
}));

export default connect(selector, {})(ElementRoot);
